<template>
  <div
    class="section-parent-checks"
    qa="section-parent-checks-container"
  >
    <div class="section-header p-2 text-center main">
      <b-col>{{ $t('diagnosis.sidebar.groups') }}</b-col>
    </div>
    <div
      class="group"
      qa="section-parent-check-group"
    >
      <div
        class="check-parent d-flex align-items-center py-2 px-2"
        qa="section-parent-check-header"
      >
        <div class="px-2">
          <b-form-checkbox
            v-model="parentCheckboxesState.allPrioritiesSelected"
            class="ml-1"
            :indeterminate="parentCheckboxesState.prioritiesIndeterminate"
            @change="selectAll($event, priorities, priorityChangeHandler)"
          />
        </div>
        <div
          v-b-toggle="'priorities'"
          class="title d-flex justify-content-between align-items-center"
          qa="priorities"
          @click="toggle=!toggle"
        >
          <span>{{ $t('diagnosis.sidebar.checkBox.priorities') }}</span>
          <i
            v-if="toggle"
            class="fal fa-chevron-down pr-1"
            aria-hidden="true"
          />
          <i
            v-else
            class="fal fa-chevron-up pr-1"
            aria-hidden="true"
          />
        </div>
      </div>
      <b-collapse id="priorities">
        <div
          v-for="(option, indexPriorities) in priorities"
          :key="indexPriorities"
          class="sub-menu-items d-flex align-items-center py-2 px-2"
        >
          <div class="px-2">
            <b-form-checkbox
              v-model="option.checked"
              class="ml-1"
              @change="priorityChangeHandler"
            >
              <p>{{ option.name }}</p>
            </b-form-checkbox>
          </div>
        </div>
      </b-collapse>
    </div>
    <div
      class="group"
      qa="section-parent-check-group"
    >
      <div class="check-parent d-flex align-items-center py-2 px-2">
        <div class="px-2">
          <b-form-checkbox
            v-model="parentCheckboxesState.allCaseTypesSelected"
            class="ml-1"
            :indeterminate="parentCheckboxesState.caseTypesIndeterminate"
            @change="selectAll($event, caseTypes, caseTypeChangeHandler)"
          />
        </div>
        <div
          v-b-toggle="'caseTypes'"
          class="title d-flex justify-content-between align-items-center"
          qa="caseTypes"
          @click="toggle=!toggle"
        >
          <span>{{ $t('diagnosis.sidebar.checkBox.caseTypes') }}</span>
          <i
            v-if="toggle"
            class="fal fa-chevron-down pr-1"
            aria-hidden="true"
          />
          <i
            v-else
            class="fal fa-chevron-up pr-1"
            aria-hidden="true"
          />
        </div>
      </div>
      <b-collapse id="caseTypes">
        <div
          v-for="(option, indexCase) in caseTypes"
          :key="indexCase"
          class="sub-menu-items d-flex align-items-center py-2 px-2"
        >
          <div class="px-2">
            <b-form-checkbox
              v-model="option.checked"
              class="ml-1"
              @change="caseTypeChangeHandler"
            >
              <p>{{ option.description }}</p>
            </b-form-checkbox>
          </div>
        </div>
      </b-collapse>
    </div>
    <div
      class="group"
      qa="section-parent-check-group"
    >
      <div class="check-parent d-flex align-items-center py-2 px-2">
        <div class="px-2">
          <b-form-checkbox
            v-model="parentCheckboxesState.allSampleTypesSelected"
            class="ml-1"
            :indeterminate="parentCheckboxesState.sampleTypesIndeterminate"
            @change="selectAll($event, sampleTypes, sampleTypeChangeHandler)"
          />
        </div>
        <div
          v-b-toggle="'sampleTypes'"
          class="title d-flex justify-content-between align-items-center"
          qa="sampleTypes"
          @click="toggle=!toggle"
        >
          <span>{{ $t('diagnosis.sidebar.checkBox.sampleTypes') }}</span>
          <i
            v-if="toggle"
            class="fal fa-chevron-down pr-1"
            aria-hidden="true"
          />
          <i
            v-else
            class="fal fa-chevron-up pr-1"
            aria-hidden="true"
          />
        </div>
      </div>
      <b-collapse :id="'sampleTypes'">
        <div
          v-for="(option, indexSample) in sampleTypes"
          :key="indexSample"
          class="sub-menu-items d-flex align-items-center py-2 px-2"
        >
          <div class="px-2">
            <b-form-checkbox
              v-model="option.checked"
              class="ml-1"
              @change="sampleTypeChangeHandler"
            >
              <p>{{ option.description }}</p>
            </b-form-checkbox>
          </div>
        </div>
      </b-collapse>
    </div>
    <div
      class="group"
      qa="section-parent-check-group"
    >
      <div class="check-parent d-flex align-items-center py-2 px-2">
        <div class="px-2">
          <b-form-checkbox
            v-model="parentCheckboxesState.allLaboratoriesSelected"
            class="ml-1"
            :indeterminate="parentCheckboxesState.laboratoriesIndeterminate"
            @change="selectAll($event, laboratories, laboratoriesChangeHandler)"
          />
        </div>
        <div
          v-b-toggle="'laboratories'"
          class="title d-flex justify-content-between align-items-center"
          qa="laboratories"
          @click="toggle=!toggle"
        >
          <span>{{ $t('diagnosis.sidebar.checkBox.laboratories') }}</span>
          <i
            v-if="toggle"
            class="fal fa-chevron-down pr-1"
            aria-hidden="true"
          />
          <i
            v-else
            class="fal fa-chevron-up pr-1"
            aria-hidden="true"
          />
        </div>
      </div>
      <b-collapse :id="'laboratories'">
        <div
          v-for="(option, indexLab) in laboratories"
          :key="indexLab"
          class="sub-menu-items d-flex align-items-center py-2 px-2"
        >
          <div class="px-2">
            <b-form-checkbox
              v-model="option.checked"
              class="ml-1"
              @change="laboratoriesChangeHandler"
            >
              <p>{{ option.labName }}</p>
            </b-form-checkbox>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import diagnosisChecksMixin from '@/modules/diagnosisModule/sideBar/diagnosisSidebarChecks/diagnosisChecksMixin'
export default {
    name: 'SectionParentChecks',
    mixins: [diagnosisChecksMixin]
}
</script>

<style lang="scss" scoped>

.section-parent-checks{
    display: none;
}

.option-nav:hover .option-nav-lock {
  visibility: visible;
}

.option-nav{
  transition: 1s;
  list-style: none;
}

.option-nav:hover{
  transition: 0.5s;
  background: vt-color(primary);
}

.check-parent{
    transition: .3s;
    cursor: pointer;
}

.check-parent:hover{
    background-color: vt-color(primary);
}

.check-parent .title{
    width: 100%;
}

.check-parent .title i{
    font-size:0.7rem;
    color: vt-color(white-light);
}

.check-parent .title span{
    font-size:font-size(very-small);
    color: vt-color(white-light);
    margin-left: 4px;
}

.sub-menu-items{
  background: vt-color(sidebar-childs-bg);
}

.sub-menu-items:hover{
  background:vt-color(primary);
}

.sub-menu-items li{
    list-style: none;
}

.sub-menu-items p{
    font-size:font-size(very-small);
    color: vt-color(white-light);
    margin-left:12px;
    margin-bottom: 0;
    cursor: pointer;
}

.section-header{
  text-transform: uppercase;
  font-size:0.9rem;
  background: vt-color(sidebar-section-header-bg);
  color: vt-color(sidebar-section-header-text);
}

.menu-popover li{
    list-style: none;
}

@media (max-width: 1300px){
  .section-header {
    font-size:0.8rem;
  }
}

</style>
